import { Injectable } from "@angular/core";
import { ConfigurationModule } from '../configuration.module';
import { QuickLinksConfiguration } from './quick-links-configuration';

@Injectable({
  providedIn: ConfigurationModule,
})
export class QuickLinkConfigurationService {
  configuration: QuickLinksConfiguration;

  constructor() {}

  loadConfiguration(configuration) {
    this.configuration = configuration;
  }
}
